import { lookupHem } from '@/pages/blueprint-lite/utils/hem';

import type { HemBenchmark, Situation } from '../types';

export interface LivingInput {
  situation: Situation;
  bankIncomeAnnual: number;
  declaredMonthly: number;
  hemBenchmarks: HemBenchmark[];
}

export interface LivingBreakdown {
  hemValue: number;
  livingMonthly: number;
}

export function computeLiving(input: LivingInput): LivingBreakdown {
  const hemValue = lookupHem(
    input.situation,
    input.bankIncomeAnnual,
    input.hemBenchmarks,
  );
  const livingMonthly =
    input.declaredMonthly > 0
      ? Math.max(input.declaredMonthly, hemValue)
      : hemValue;
  return { hemValue, livingMonthly };
}
